import { render, staticRenderFns } from "./broadcastList.vue?vue&type=template&id=3a3a96dc&scoped=true&"
import script from "./broadcastList.vue?vue&type=script&lang=js&"
export * from "./broadcastList.vue?vue&type=script&lang=js&"
import style0 from "./broadcastList.vue?vue&type=style&index=0&id=3a3a96dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3a96dc",
  null
  
)

export default component.exports